import { Directive, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Directive()
// eslint-disable-next-line @angular-eslint/directive-class-suffix
export abstract class SelectableInputBaseComponent<T> implements OnInit, OnDestroy {
	@Input() options?: Array<T | null>;
	@Input() defaultValue?: T | null;
	@Input() optionalText?: string;
	@Input() districtClass?: string;
	@Input() optionsText: (t: T | null) => string;
	@Input() optionGroupHeader: (element: any, elements: Array<any>, index: number | string) => void
	@Input() searchFunction: (searchString: string, t: T) => boolean;
	@Input() stayOpen = false;
	@Input() startWithFocus: boolean = false;
	@Output() valueChange = new EventEmitter<T | null>();

	public subscriptions: Array<Subscription> = [];
	public trigger = new Subject<string>();
	public searches: Array<T | null> = [];
	public value?: string;
	public showList: boolean = this.stayOpen;

	@HostListener('focusout', ["$event"])
	public onFocusOut(e: FocusEvent) {
		if (!this.stayOpen) {
			this.showList = false;
		}
	}

	public ngOnInit() {
		setTimeout(() => {
			if (!this.startWithFocus) {
				this.resetSearchValueToSelectedValue();
			}
		}, 0);
		this.subscriptions.push(this.trigger.pipe(debounceTime(300)).pipe(distinctUntilChanged()).subscribe(x => {
			this.setSearchData(x);
			this.value = x;
		}));
	}

	public resetSearchValueToSelectedValue() {
		this.value = this.defaultValue ? this.optionsText(this.defaultValue) : this.optionalText;
	}

	public startSearch(event: Event) {
		const text = event.target as HTMLInputElement;

		this.trigger.next(text.value);
	}

	public setSearchData(searchString: string) {
		const result = searchString.length > 0
			? this.findOptions(searchString)
			: this.options;

		this.searches = result || [];
	}

	private findOptions(text: string) {
		return this.options?.filter(x => {
			if (x)
				return this.searchFunction(text, x);
			else
				return null
		});
	}

	public ngOnDestroy() {
		this.subscriptions.forEach(x => x.unsubscribe());
	}

	abstract onSelect(search: T): void;
}
